import React, { Component } from 'react';
import 'react-select/dist/react-select.css';
import classNames from 'classnames';
import { Input } from 'react-bootstrap';
import { ROOT_URL, ROOT_API_URL, companyCodeTitle } from '../../actions/root_url';

const isEcity = ROOT_API_URL === 'https://ct-scm.truckxi.com/api/' || ROOT_API_URL === 'https://ctstage-scm.truckxi.com/api/';

export class InputField extends Component {
  render() {
    const {
      input, onFocus, className, meta: { touched, error },
    } = this.props;
    if (this.props.decimal) {
      const decimal = parseInt(this.props.decimal);
      input.value = (parseFloat(input.value) || 0).toFixed(decimal);
    }
    const inputClass = classNames({ 'parsley-error': touched && error }, 'form-control', className);
    if (onFocus != null) {
      return (
        <div>
          {touched && error && <span className="parsley-error-message">{error}</span>}
          {(this.props.onChange) ?
            <Input {...input} disabled={this.props.disabled} style={this.props.style} standalone type={this.props.type || 'text'} maxLength={this.props.maxLength} onChange={this.props.onChange} value={this.props.value || this.props.input.value} className={inputClass} ref={(input) => { this.myInput = input; }} onKeyPress={this.props.onKeyPress} placeholder={this.props.placeholder} onFocus={onFocus} /> :
            <Input {...input} disabled={this.props.disabled} style={this.props.style} maxLength={this.props.maxLength} className={inputClass} ref={(input) => { this.myInput = input; }} onKeyPress={this.props.onKeyPress} standalone type="text" placeholder={this.props.placeholder} onFocus={onFocus} /> }
        </div>
      );
    }
    return (
      <div>
        {touched && error && <span className="parsley-error-message">{error}</span>}
        {(this.props.onChange) ?
          <Input {...input} disabled={this.props.disabled} style={this.props.style} standalone type={this.props.type || 'text'} maxLength={this.props.maxLength} onChange={this.props.onChange} value={this.props.value} className={inputClass} ref={(input) => { this.myInput = input; }} onKeyPress={this.props.onKeyPress} placeholder={this.props.placeholder} /> :
          <Input {...input} disabled={this.props.disabled} style={this.props.style} maxLength={this.props.maxLength} className={inputClass} ref={(input) => { this.myInput = input; }} onKeyPress={this.props.onKeyPress} standalone type="text" placeholder={this.props.placeholder} /> }
      </div>
    );
  }
}

export class PasswordInputField extends Component {
  render() {
    const {
      input, onFocus, className, meta: { touched, error },
    } = this.props;
    const inputClass = classNames({ 'parsley-error': touched && error }, 'form-control', className);
    return (
      <div>
        {touched && error && <span className="parsley-error-message">{error}</span>}
        <Input {...input} className={inputClass} ref={(input) => { this.myInput = input; }} onKeyPress={this.props.onKeyPress} standalone type="password" placeholder={this.props.placeholder} />
      </div>
    );
  }
}

export class ControlledInputField extends Component {
  render() {
    let {
      input, onFocus, placeholder, className, meta: { touched, error },
    } = this.props;
    if (this.props.decimal) {
      const decimal = parseInt(this.props.decimal);
      placeholder = (parseFloat(placeholder) || 0).toFixed(decimal);
    }
    const inputClass = classNames({ 'parsley-error': touched && error }, 'form-control', className);
    if (onFocus != null) {
      return (
        <div>
          {touched && error && <span className="parsley-error-message">{error}</span>}
          <Input {...input} className={inputClass} ref={(input) => { this.myInput = input; }} onKeyPress={this.props.onKeyPress} standalone type="text" value={placeholder} onChange={this.props.onChange} onFocus={onFocus} disabled={this.props.disabled}/>
        </div>
      );
    }

    return (
      <div>
        {touched && error && <span className="parsley-error-message">{error}</span>}
        <Input {...input} className={inputClass} ref={(input) => { this.myInput = input; }} onKeyPress={this.props.onKeyPress} standalone type="text" value={placeholder} onChange={this.props.onChange} />
      </div>
    );
  }
}


export class DisabledInputField extends Component {
  render() {
    const { input, className, meta: { touched, error } } = this.props;
    const inputClass = classNames({ 'parsley-error': touched && error }, 'form-control', className);
    if (this.props.placeholder || this.props.placeholder == '' || this.props.placeholder == 0) {
      return (
        <div>
          {touched && error && <span className="parsley-error-message">{error}</span>}
          <Input {...input} className={inputClass} standalone type="text" value={this.props.placeholder} disabled />
        </div>
      );
    }
    return (
      <div>
        {touched && error && <span className="parsley-error-message">{error}</span>}
        <Input {...input} className={inputClass} standalone type="text" disabled />
      </div>
    );
  }
}
// let renderInputField = props => {
//     const inputClass = classNames({ 'parsley-error': props.meta.touched && props.meta.error }, 'form-control')
//     return (
//         <div>
//             {props.meta.touched && props.meta.error && <span className="parsley-error-message">{props.meta.error}</span>}
//             <Input {...props.input} className={inputClass} type="text"/>
//         </div>
//     )
// }

export class ControllabledStateInputField extends Component {
  render() {
    const {
      input, onFocus, className, meta: { touched, error },
    } = this.props;
    const inputClass = classNames({ 'parsley-error': touched && error }, 'form-control', className);
    let placeholder = '';
    if (this.props.placeholder) { placeholder = (this.props.placeholder).slice(4, 7); }

    if (this.props.isDisabled) {
      if (this.props.placeholder) {
        return (
          <div>
            {touched && error && <span className="parsley-error-message">{error}</span>}
            <Input {...input} className={inputClass} standalone type="text" value={this.props.placeholder} disabled />
          </div>
        );
      }
      return (
        <div>
          {touched && error && <span className="parsley-error-message">{error}</span>}
          <Input {...input} className={inputClass} standalone type="text" disabled />
        </div>
      );
    }
    if (onFocus != null) {
      return (
        <div>
          {touched && error && <span className="parsley-error-message">{error}</span>}
          <Input {...input} className={inputClass} ref={(input) => { this.myInput = input; }} onKeyPress={this.props.onKeyPress} standalone type="text" placeholder={placeholder} onFocus={onFocus} />
        </div>
      );
    }
    return (
      <div>
        {touched && error && <span className="parsley-error-message">{error}</span>}
        <Input {...input} className={inputClass} ref={(input) => { this.myInput = input; }} onKeyPress={this.props.onKeyPress} standalone type="text" placeholder={placeholder} />
      </div>
    );
  }
}

export default InputField;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/inputField.jsx